import React from 'react'

import { useLinkTreeMenu } from './_load/LinkTreeMenuLoader'
import { useSaveLinkTreeMenu } from './_request/saveLinkTreeMenu'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditLinkTreeMenuForm = () => {
  const linktree = useLinkTreeMenu()
  const [onSubmit, { loading, error }] = useSaveLinkTreeMenu()

  const initialState = linktree || {}

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditLinkTreeMenuForm
